"use client";

import { Monitor } from "lucide-react";
import { useEffect, useState } from "react";

export function MobileNotSupported() {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			const userAgent = navigator.userAgent.toLowerCase();
			const mobileKeywords =
				/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
			const isMobileDevice = mobileKeywords.test(userAgent);
			// Only block on phone screens (not tablets or small laptops)
			const isSmallScreen = window.innerWidth < 480;
			const shouldBlock = isMobileDevice && isSmallScreen;
			setIsMobile(shouldBlock);

			// Prevent ALL scrolling when mobile view is active
			if (shouldBlock) {
				document.body.style.overflow = "hidden";
				document.body.style.position = "fixed";
				document.body.style.width = "100%";
				document.body.style.height = "100%";
				document.documentElement.style.overflow = "hidden";
				document.documentElement.style.height = "100%";
			} else {
				document.body.style.overflow = "";
				document.body.style.position = "";
				document.body.style.width = "";
				document.body.style.height = "";
				document.documentElement.style.overflow = "";
				document.documentElement.style.height = "";
			}
		};

		checkMobile();
		window.addEventListener("resize", checkMobile);

		return () => {
			window.removeEventListener("resize", checkMobile);
			document.body.style.overflow = "";
			document.body.style.position = "";
			document.body.style.width = "";
			document.body.style.height = "";
			document.documentElement.style.overflow = "";
			document.documentElement.style.height = "";
		};
	}, []);

	if (!isMobile) return null;

	return (
		<div
			className="fixed inset-0 z-[9999] flex h-screen w-screen items-center justify-center overflow-hidden overscroll-none touch-none bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950"
			style={{ touchAction: "none" }}
		>
			<div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.05),transparent_50%)]" />
			<div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-40" />

			<div className="relative w-full max-w-sm space-y-6 px-6 py-8 sm:space-y-8">
				<div className="flex justify-center">
					<div className="relative">
						<div className="absolute inset-0 animate-pulse rounded-full bg-blue-500/20 blur-2xl" />
						<div className="relative rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-xl sm:p-5">
							<Monitor
								className="h-10 w-10 text-blue-400 sm:h-14 sm:w-14"
								strokeWidth={1.5}
							/>
						</div>
					</div>
				</div>

				<div className="space-y-3 text-center sm:space-y-4">
					<h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
						Desktop Only
					</h1>
					<p className="text-sm leading-relaxed text-slate-400 sm:text-base">
						Our platform is optimized for desktop browsers. Please access from a
						larger screen for the best experience.
					</p>
				</div>

				<div className="rounded-xl border border-white/10 bg-white/5 p-3 backdrop-blur-sm sm:p-4">
					<div className="flex items-start gap-2.5 sm:gap-3">
						<div className="mt-0.5 flex-shrink-0">
							<svg
								className="h-4 w-4 text-blue-400 sm:h-5 sm:w-5"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth={2}
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
								/>
							</svg>
						</div>
						<p className="text-xs text-slate-300 sm:text-sm">
							Mobile support is coming soon. We're working hard to bring you a
							great mobile experience.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
